module.exports = __webpack_public_path__ + "img/favorites-main-new.webp";